import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { Customer, customerToOrderState } from '@models/customer';
import { OrderState } from '../models';
import { Product } from '@models/product';

export function createInitialState(product?: Product): OrderState {
    return {
        productSlug: product?.slug,
        currentStep: product?.orderConfig.steps[0].slug || '',
        completedSteps: [],
        invalidSteps: [],
        insurants: [],
        insuredObjects: [],
        tags: new Map(),
    };
}

/**
 * @description stores information relevant for the order form:
 *  User and order data, available steps and current step, product
 *  config and so on. Attention: Components should never inject this!
 *  Use OrderQuery to gain access to the current state of the store,
 *  and OrderService to update its state.
 * @see {@link OrderService}
 * @see {@link OrderQuery}
 */
@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'order', resettable: true })
export class OrderStore extends Store<OrderState> {
    public constructor() {
        super(createInitialState());
    }

    public reinit(product: Product, customer?: Customer | null): void {
        let initialState: OrderState;

        if (customer) {
            initialState = {
                ...createInitialState(product),
                ...customerToOrderState(customer),
            };
        } else {
            initialState = { ...createInitialState(product) };
        }
        if (typeof product.onInit === 'function') {
            initialState = { ...initialState, ...product.onInit(initialState, product) };
        }
        this._setState(initialState);
    }
}
